import { dictWithUrl } from '@/components/lots/api';

export const PRIVILEGE_MOVE_CODE = '040100016';

/**
 * 发车单状态
 * 字典: DISPATCH_STATUS
 */
export class DispatchStatus {
    static IN_TRANSIT = 40; // 发车单状态-在途
}

/**
 * 运输单状态
 */
export class TransportStatus {
    static TO_DISPATCH = 30; // 运输单状态-待发车
}

/**
 * 运输单状态 翻译成名称
 * 字典: TRANSPORT_STATUS
 */
export class TransportStatusNameTranslator {
    dict;

    constructor(dict) {
        this.dict = dict;
    }

    static async create() {
        const dict = (await dictWithUrl('TRANSPORT_STATUS')).data['TRANSPORT_STATUS'];
        return new TransportStatusNameTranslator(dict);
    }

    toName(value, defaultName = null) {
        return this.dict[value] || defaultName;
    }
}

/**
 * 车次状态
 * 字典: TRAIN_STATUS
 */
export class TrainStatus {
    static TO_ARRANGE = 5; // 车次状态-待排车
    // static TO_ARRIVE = 10; // 车次状态-待到车
    // static TO_LOAD = 20; // 车次状态-待装车
    static TO_SEND = 30; // 车次状态-待发车
}

/**
 * 车次状态 翻译成名称
 * 字典: TRAIN_STATUS
 */
export class TrainStatusNameTranslator {
    dict;

    constructor(dict) {
        this.dict = dict;
    }

    static async create() {
        const dict = (await dictWithUrl('TRAIN_STATUS')).data['TRAIN_STATUS'];
        return new TrainStatusNameTranslator(dict);
    }

    toName(value, defaultName = null) {
        return this.dict[value] || defaultName;
    }
}
// 运输单状态
export class TaskStatusName {
    dict;

    constructor(dict) {
        this.dict = dict;
    }

    static async create() {
        const dict = (await dictWithUrl('TRANSPORT_STATUS')).data['TRANSPORT_STATUS'];
        return new TaskStatusName(dict);
    }

    toName(value, defaultName = null) {
        return this.dict[value] || defaultName;
    }
}

/**
 * 采购渠道 翻译成名称
 * 字典: OTP_TMS_PROCUREMENT_CHANNEL
 */
export class ProcurementChannelTranslator {
    dict;

    constructor(dict) {
        this.dict = dict;
    }

    static async create() {
        const dict = (await dictWithUrl('OTP_TMS_PROCUREMENT_CHANNEL')).data['OTP_TMS_PROCUREMENT_CHANNEL'];
        return new ProcurementChannelTranslator(dict);
    }

    toName(value, defaultName = null) {
        return this.dict[value] || defaultName;
    }
}
